export default "__VITE_ASSET__CQxo2c14__"